import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import HorizontalBar from '@/shared/components/charts/HorizontalBar';

import { listItemMsg } from '@/shared/components/FormattedListValue';
import {
  datasetColors,
  getStateParamsFromEvent,
  getStateParamsFromTask,
} from './taskDashboardUtils';
import messages from '../taskMessages';

const chartOptions = {
  responsive: true,
  indexAxis: 'y',
  maintainAspectRatio: false,

  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      grid: { display: false },
    },
  },
  layout: {
    padding: {
      bottom: 100,
    },
  },
  plugins: {
    tooltip: {
      enabled: true,
      mode: 'index',
      displayColors: true,
      position: 'nearest',
      callbacks: {
        footer(items) {
          if (!items || !items.length) return '';
          const [first] = items;
          const { totalLabel } = first.dataset;
          const total = items.reduce((sum, i) => sum + (i.raw || 0), 0);

          return `${totalLabel}: ${total}`;
        },
      },
    },
  },
};

// Convert data from http call to chart data
const transformData = (data, intl) => {
  if (!data) return null;
  const labels = data.map(x => x.label);

  const totalLabel = intl.formatMessage(messages.Total);
  const datasets = [
    {
      label: intl.formatMessage(listItemMsg('taskstatus', 2, 'Done')),
      backgroundColor: datasetColors[0],
      data: data.map(x => x.done || 0),
      totalLabel,
    },
    {
      label: intl.formatMessage(listItemMsg('taskstatus', 1, 'In Progress')),
      backgroundColor: datasetColors[1],
      data: data.map(x => x.inProgress || 0),
      totalLabel,
    },
    {
      label: intl.formatMessage(listItemMsg('taskstatus', 0, 'Todo')),
      backgroundColor: datasetColors[2],
      data: data.map(x => x.todo || 0),
      totalLabel,
    },
    {
      label: intl.formatMessage(messages.Blocked),
      backgroundColor: datasetColors[3],
      data: data.map(x => x.blocked || 0),
      totalLabel,
    },
  ];

  return {
    labels,
    datasets,
  };
};

const QuantitiesDashboard = ({ data, intl, onOpenOverview }) =>
  data ? (
    <HorizontalBar
      data={transformData(data, intl)}
      options={chartOptions}
      height={165 + data.length * 20}
      onElementClick={e => {
        if (!e) return;
        const params = getStateParamsFromEvent(data, e);
        if (params) onOpenOverview(params);
      }}
      onLabelClick={idx => {
        const params = getStateParamsFromTask(data[idx]);
        if (params) onOpenOverview(params);
      }}
    />
  ) : null;
QuantitiesDashboard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  onOpenOverview: PropTypes.func,
  intl: intlShape.isRequired,
};
QuantitiesDashboard.defaultProps = {
  data: null,
  onOpenOverview: () => {},
};
export default injectIntl(QuantitiesDashboard);
